var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGeofencing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/geofencing/default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,8 L16,11.3466667 L16,11.7822222 L12.96,12.96 L11.7866667,16 L11.3511111,16 L8,8 Z M13,0 L13.1762728,0.00509269341 C14.6927538,0.0929596233 15.9070404,1.30724616 15.9949073,2.82372721 L16,3 L16,8 L14,8 L14,3 L13.9932723,2.88337887 C13.9399506,2.42429701 13.575703,2.06004937 13.1166211,2.00672773 L13,2 L3,2 L2.88337887,2.00672773 C2.42429701,2.06004937 2.06004937,2.42429701 2.00672773,2.88337887 L2,3 L2,13 L2.00672773,13.1166211 C2.06004937,13.575703 2.42429701,13.9399506 2.88337887,13.9932723 L3,14 L8,14 L8,16 L3,16 L2.82372721,15.9949073 C1.30724616,15.9070404 0.0929596233,14.6927538 0.00509269341,13.1762728 L0,13 L0,3 L0.00509269341,2.82372721 C0.0929596233,1.30724616 1.30724616,0.0929596233 2.82372721,0.00509269341 L3,0 L13,0 Z M6.13,4.11 L6.72,5.41 L8.02,6.01 L6.72,6.6 L6.13,7.9 L5.54,6.6 L4.23,6.01 L5.54,5.41 L6.13,4.11 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/geofencing/default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#005082",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Neutral-Fill",
    mask: "url(#mask-2)",
    fill: "#005082"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Fill",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeofencing);
export default __webpack_public_path__ + "static/media/icon_geofencing.1db6cfc5483ea9b0fd30dd24b25ab1db.svg";
export { ForwardRef as ReactComponent };